import { Carer, UserRole } from '@lmc/ts-common'
import { useSelector } from 'react-redux'
import useAbilityStore from './useAbilityStore'
import { ForcedSubject } from '@casl/ability'

export type RoleAbilityProp = {
  i: string
  this: string | ForcedSubject<string>
}[]

export type RoleAccessProp = UserRole | UserRole[]

const useRoleAccess = (
  roles?: RoleAccessProp,
  abilities?: RoleAbilityProp
): boolean => {
  const userRole = useSelector(
    (state: { global: { user: Carer } }) => state.global.user?.role
  )

  if (roles) {
    const roleAccess = Array.isArray(roles)
      ? roles.includes(userRole)
      : userRole === roles

    if (roleAccess) {
      return true
    }
  }

  if (abilities && abilities.length) {
    const abilityInstance = useAbilityStore()

    return abilities.every(({ i: action, this: subject }) =>
      abilityInstance.can(action, subject)
    )
  }

  return false
}

export default useRoleAccess
